import {getAbsoluteUrl} from "../../utils/urlUtill";
import {CONFIGURATION_INITIALIZER} from "../../../initializers/ActiveBrandInitializer";
import {IHttpService} from "angular";

export class MainService {
    private _$http: angular.IHttpService;
    private principleLoaded: boolean;
    private principleLoadedCallbacks: any[];
    private principle: any;

    constructor($http: IHttpService) {
        this._$http = $http;
        this.principleLoaded = false;
        this.principleLoadedCallbacks = [];
        this.assignPrinciple = this.assignPrinciple.bind(this);

        this.getPrincipal().then(
            (resp) => {
                this.principleLoaded = true;
                this.principle = resp;
                this.principleLoadedCallbacks.forEach(c => c(this.principle));
            },
            (resp) => {
                if (resp.status === 404) {
                    console.log('not authenticated');
                    console.log(resp);
                }
            }
        );

    }

    getPrincipal() {
        return CONFIGURATION_INITIALIZER.getPrinciple();
    }

    getUpdatedPrinciple() {
        return this._$http({method: 'GET', url: getAbsoluteUrl('principal')});
    }

    getBrands() {
        return this._$http({method: 'GET', url: getAbsoluteUrl('brands')});
    }

    changeCurrentBrand(newBrandId) {
        return this._$http({method: 'GET', url: getAbsoluteUrl('changeBrand/' + newBrandId)});
    }

    assignPrinciple = (callback) => {
        if (this.principleLoaded) {
            callback(this.principle);
        } else {
            this.principleLoadedCallbacks.push(callback);
        }
    }
}